<template>
  <v-card>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="guardar()"
    >
      <v-card-title>
        NUEVO
        <v-spacer/>
        <v-btn icon @click="$emit('close')">
          X
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <v-autocomplete
                v-if="cajero.id === 0"
                v-model="cajero.user_id"
                label="Funcionario *"
                :items="usuarios"
                item-text="funcionario.info"
                item-value="id"
                :rules="[v => !!v || 'Funcionario es requerido']"
                clearable
                :loading="loading"
                :prepend-icon="'mdi-update'"
                :append-outer-icon="'mdi-account-plus'"
                @click:prepend="listarFuncionarios()"
                @click:append-outer="crearNuevoFuncionario()"
            />
            <label v-else>Funcionario: {{ cajero.user.funcionario.info }}</label>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="cajero.ventanilla"
                label="Vetanilla *"
                type="number"
                @keypress="patterns.onlyNumber($event)"
                :rules="[v => !!v || 'Ventanilla es requerida',
                       v => v >= 1 && v <= 9999 || 'Ventanilla debe estar entre 1 y 9999']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
                v-model="cajero.rol"
                label="Rol *"
                :items="['cajero', 'supervisor', 'administrador']"
                :rules="[v => !!v || 'Rol es requerido']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="cajero.entidad"
                label="Entidad *"
                @keyup="patterns.toUpper($event)"
                :rules="[v => !!v || 'Entidad es requerida',
                       v => v.toString().length >= 3 && v.toString().length <= 100 || 'Entidad debe tener entre 1 y 1000 letras']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="cajero.sucursal"
                label="Sucursal *"
                @keyup="patterns.toUpper($event)"
                :rules="[v => !!v || 'Sucursal es requerida',
                       v => v.toString().length >= 3 && v.toString().length <= 100 || 'Sucursal debe tener entre 1 y 1000 letras']"
            />
          </v-col>
          <v-col cols="12" md="12">
            <v-text-field
                v-model="cajero.cantidad_factura"
                label="Porcentaje de facturas que el cajero puede seleccionar en consumo básico *"
                @keypress="patterns.onlyNumber($event)"
                :rules="[v => !!v || 'Porcentaje de facturas es requerida',
                       v => v >= 1 && v <= 100 || 'Ventanilla debe estar entre 1 y 100']"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-footer>
        <v-spacer/>
        <v-btn color="primary" type="submit">
          Guardar
        </v-btn>
      </v-footer>
    </v-form>

    <v-dialog v-model="showDialogFuncionario" persistent width="400px">
      <funcionario-form
          @close="cerrarDialogoFuncionario()"
      />
    </v-dialog>

  </v-card>
</template>

<script lang="ts">
import {Vue} from "vue-property-decorator";
import Component from "vue-class-component";
import {cajeroStore} from "@/store/cajeroStore";
import {Cajero} from "@/models/Cajero";
import {User} from "@/models/User";
import {CajeroService} from "@/services/CajeroService";
import FuncionarioForm from "@/views/cajeros/FuncionarioForm.vue";
import {Funcionario} from "@/models/Funcionario";
import {Pattern} from "@/addons/Pattern";

@Component({
  name: "CajeroForm",
  components: {FuncionarioForm}
})
export default class CajeroForm extends Vue {
  private patterns = Pattern;

  private cajeroStore = cajeroStore();
  private cajeroService = CajeroService.getInstance();
  valid = true;
  $refs!: {
    form: HTMLFormElement
  }

  get cajero(): Cajero {
    return this.cajeroStore.cajero;
  }

  get usuarios(): User[] {
    return this.cajeroStore.usuarios;
  }

  get loading(): boolean {
    return this.cajeroStore.loading;
  }

  get showDialogFuncionario(): boolean {
    return this.cajeroStore.showDialogFuncionario;
  }

  mounted() {
    this.listarFuncionarios();
  }

  listarFuncionarios() {
    this.cajeroService.getFuncionarios();
  }

  crearNuevoFuncionario() {
    this.cajeroStore.funcionario = new Funcionario();
    this.cajeroStore.showDialogFuncionario = true;
  }

  cerrarDialogoFuncionario() {
    this.cajeroStore.showDialogFuncionario = false;
    this.listarFuncionarios();
  }

  guardar() {
    if (!this.$refs.form.validate()) {
      return;
    }

    if(this.cajero.id === 0) {
      this.cajeroService.store(this.cajero);
    } else {
      this.cajeroService.update(this.cajero);
    }
  }
}


</script>

<style scoped>

</style>